import cloneIfCantEditPlanAction from '../clone-if-cant-edit'
import updatePlanAction from '../update'
import PLANS_ACTION from '../../constants/action'
import { PLAN_KEY } from '../../../plan/model/constants'

function updateLocalHasAssociationChangePlanAction () {
  return async (dispatch) => {
    await dispatch(cloneIfCantEditPlanAction())

    dispatch(updatePlanAction({
      type: PLANS_ACTION.UPDATE_LOCAL_HAS_ASSOCIATION_CHANGE,
      payload: {
        key: PLAN_KEY.HAS_ASSOCIATION_CHANGE,
        value: true
      }
    }))
  }
}

export default updateLocalHasAssociationChangePlanAction
